module.exports = __webpack_public_path__ + "img/N330fuji-1-EN.be60493a.jpg";